import type { CatalogNode, CopyModule } from './types'

/**
 * Declare a feature's English catalogue.
 *
 * ```ts
 * export const checksCopy = defineCopy('checks', {
 *   page: { title: 'Checks', empty: 'No checks due right now.' },
 *   plan: { dueCount: { one: '{count} check due', other: '{count} checks due' } },
 * })
 * ```
 *
 * `namespace` **must equal the feature directory name** — the locale loader
 * derives the namespace of a `copy.<locale>.ts` from its directory, so a
 * mismatch means the translation registers under a name nothing reads and the
 * app silently renders English forever. `copy-namespaces.test.ts` in
 * `apps/web` asserts the two agree.
 *
 * The `const` type parameter is what keeps `'Checks'` as the literal type
 * `'Checks'` rather than widening to `string`. Without it `Placeholder<S>`
 * would have nothing to read and every leaf would resolve to a plain string —
 * including the ones that need arguments, which would then be silently rendered
 * with `{name}` still in them.
 */
export function defineCopy<const T extends CatalogNode>(namespace: string, catalog: T): CopyModule<T> {
  return Object.freeze({ namespace, en: catalog })
}
